import type { RetrofitName } from '@/shared/types/assessment.types'
import { httpClient } from '@/shared/utils/http-client'

const EB_HUB_API_BASE_URL = import.meta.env.DEV
  ? '/eb-hub-service/eb-hub/v1/custom-package'
  : 'https://eb-hub-service.enter.de/eb-hub/v1/custom-package'

export interface CreateCustomPackageResponse {
  customPackageId: string
}

class MeasuresOverviewApi {
  /**
   * Create a custom package for a specific building
   * @param buildingUuid - The UUID of the building
   * @param retrofitNames - Array of retrofit names to include in the custom package
   * @returns Promise with the created custom package ID
   */
  async createCustomPackage(
    buildingUuid: string,
    retrofitNames: RetrofitName[]
  ): Promise<CreateCustomPackageResponse> {
    const url = `${EB_HUB_API_BASE_URL}/${buildingUuid}`
    return await httpClient.post<CreateCustomPackageResponse>(url, retrofitNames)
  }

  /**
   * Set a custom package as the main selected package
   * @param customPackageUuid - The UUID of the custom package
   * @returns Promise resolving when the operation is complete
   */
  async setCustomPackageAsMain(customPackageUuid: string): Promise<void> {
    const url = `${EB_HUB_API_BASE_URL}/${customPackageUuid}/set-main`
    return await httpClient.put<void>(url)
  }

  /**
   * Delete a custom package
   * @param customPackageUuid - The UUID of the custom package to delete
   * @returns Promise resolving when the operation is complete
   */
  async deleteCustomPackage(customPackageUuid: string): Promise<void> {
    const url = `${EB_HUB_API_BASE_URL}/${customPackageUuid}`
    await httpClient.delete<void>(url)
  }
}

export const measuresOverviewApi = new MeasuresOverviewApi()
